var map = {
	"./modalSetProjectName": 179,
	"./modalSetProjectName.vue": 179
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1263;


//////////////////
// WEBPACK FOOTER
// ./src/custom/stiemert/dialogs ^\.\/.*$
// module id = 1263
// module chunks = 147